export default {
  TAXES: "Taxes",
  TAXES_LIST: "Taxes List",
  ADD_TAX: "Add Tax",
  TAX_ADDED: "Tax Added",
  EDIT_TAX: "Edit Tax",
  TAX_UPDATED: "Tax Updated",
  DELETE_THIS_TAX: "Delete this tax?",
  TAX_DELETED: "Tax Deleted",
  VIEW_TAX: "Tax",
  TYPE: "Type",
  SAME_TAXES:
    'One or more taxes have already been registered with the name {name}. Is it the same tax? Click "Continue" to save if so, otherwise click "Cancel".',
  CREATED_AT: "Created at",
  PERCENTAGE: "Percentage",
  AMOUNT: "Amount",
  DENOMINATION: "Label",
  TRANSACTION: "Transaction",
  TRANSACTION_REQUIRED: "Please specify the transaction",
  SALES: "Sales",
  PURCHASES: "Purchases",
  ACTIVE: "Active",
  DEACTIVATED: "Deactivated",
  VALUE: "Value",
  TAX_NUMBER: "Tax Number",
  CALCULATION_BASE: "Calculation Base",
  CALCULATION_BASE_REQUIRED: "Please specify the calculation base",
  AFTER_TAX: "After tax amount",
  BEFORE_TAX: "Before tax amount",
  ACTIVATION: "Activation",
  NO_TAXES_FOUND: "No taxes found",
  SELECTED_TAXES: "Selected Taxes",
  CALCULATION_TYPE: "Calculation Type",
  DENOMINATION_REQUIRED: "Please enter the label",
  NAME_REQUIRED: "Please enter the name",
  AMOUNT_REQUIRED: "Please enter the amount",
  PERCENTAGE_REQUIRED: "Please specify the percentage",
  TYPE_REQUIRED: "Please select the type",
  SELECT: "Select a tax",
  SELECT_TAXES: "Add taxes",
  REQUIRED: "Please select the taxes to add",

  // Tax Groups
  TAX_GROUPS: "Tax Groups",
  TAX_GROUPS_LIST: "Tax Groups List",
  ADD_TAX_GROUP: "Add Tax Group",
  TAX_GROUP_ADDED: "Tax Group Added",
  EDIT_TAX_GROUP: "Edit Tax Group",
  TAX_GROUP_UPDATED: "Tax Group Updated",
  DELETE_THIS_TAX_GROUP: "Delete this tax group?",
  TAX_GROUP_DELETED: "Tax Group Deleted",
  VIEW_TAX_GROUP: "Tax Group",
  SAME_TAX_GROUPS:
    'One or more groups have already been registered with the name {name}. Is it the same group? Click "Continue" to save if so, otherwise click "Cancel".',
  EDIT_TAXES: "Edit Taxes",
  TAX_GROUP_REQUIRED: "Please select the applicable tax group",
  COUT: "Cost",
  COUNTRY_CODE: "Country Code",
  COUNTRY_CODE_REQUIRED: "Please specify the country code",
  TAX_GROUP_SELECT: "Select a tax group",
  NO_TAX_GROUPS_FOUND: "No tax groups found",
};
